import {Component, Input, OnInit} from '@angular/core';
import {ViewCell} from 'ng2-smart-table';

@Component({
    template: `
        <div [ngClass]="setClass()">{{renderValue}}</div>
  `
})
export class PageSpeedScoreRenderComponent implements OnInit, ViewCell {
    renderValue: string;

    @Input()
    value: any;
    @Input()
    rowData: any;

    score: number;
    cssClasses: Array<string> = ['table-score-red-color', 'table-score-orange-color', 'table-score-green-color'];

    constructor() {
    }

    ngOnInit() {
        this.renderValue = this.value;
    }

    setClass(): string {
        this.score = parseInt(this.value, 10);
        if (this.score >= 0 && this.score <= 64 ) {
            return this.cssClasses[0];
        } else if (this.score > 64 && this.score < 85) {
            return this.cssClasses[1];
        } else {
            return this.cssClasses[2];
        }
    }
}



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/ng-smart-table-renderers/table-cell-renderers/page-speed-score-render.component.ts